
interface Number {
    hasFlag(flag: number): boolean;
    roundToDigits(digits: number): number;
}

Number.prototype.hasFlag = function (flag: number): boolean {
    return (this & flag) == flag;
};

Number.prototype.roundToDigits = function (digits: number): number {
    return +(Math.round(+(`${this}e+${digits}`)) + `e-${digits}`);
};


// WEBPACK FOOTER //
// ./app/common/helpers/enumHelper.ts